import { useSearchParams } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { MaskedLines, Reveal, ImageReveal } from "@/components/motion/Reveal";
import { QuoteWizard } from "@/components/QuoteWizard";
import { useSettings } from "@/hooks/useData";
import { IMG } from "@/lib/content";
import { FAQ } from "@/components/sections/FAQ";

const PRESETS = {
  business: { object_type: "Büro", cleaning_types: ["Unterhaltsreinigung"] },
  privat: { object_type: "Wohnung" },
  umzug: { object_type: "Wohnung", cleaning_types: ["Umzugsreinigung"] },
};

export default function Kontakt() {
  const s = useSettings();
  const [params] = useSearchParams();
  const preset = PRESETS[params.get("typ")];
  return (
    <>
      <SEO title="Kontakt & Offertanfrage" description="Kostenlose Offerte anfragen: Wohnung, Haus, Büro, Praxis, Gewerbe oder Liegenschaft. Wir melden uns innerhalb von ein bis zwei Arbeitstagen." path="/kontakt" />
      <section className="bg-paper pt-36 md:pt-44 pb-20 md:pb-28">
        <div className="container-x grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <p className="label text-mute mb-8 flex items-center gap-4"><span className="w-6 h-px bg-ink/40" /> Kontakt</p>
            <MaskedLines as="h1" inView delay={0.2} lines={["Offerte", "anfragen."]} data-testid="page-title" className="display text-5xl sm:text-6xl lg:text-7xl text-ink" />
            <Reveal delay={0.5} className="mt-10">
              <p className="text-base md:text-lg text-mute leading-relaxed max-w-sm">Fünf kurze Schritte. Kostenlos und unverbindlich. Wir melden uns in der Regel innerhalb von ein bis zwei Arbeitstagen.</p>
            </Reveal>
            <Reveal delay={0.6} className="mt-14 flex flex-col gap-8">
              <div>
                <p className="label text-mute mb-3">Telefon</p>
                <a href={`tel:${s?.phone_link || ""}`} data-testid="contact-phone" className="display text-2xl text-ink link-line">{s?.phone}</a>
              </div>
              <div>
                <p className="label text-mute mb-3">E-Mail</p>
                <a href={`mailto:${s?.email || ""}`} data-testid="contact-email" className="display text-2xl text-ink link-line break-all">{s?.email}</a>
              </div>
              <div>
                <p className="label text-mute mb-3">Adresse</p>
                <p className="text-base text-ink leading-relaxed">{s?.company}<br />{s?.address_line1}<br />{s?.address_line2}</p>
              </div>
              {s?.whatsapp && (
                <a href={`https://wa.me/${s.whatsapp}`} target="_blank" rel="noreferrer" className="label link-line w-max text-ink">WhatsApp</a>
              )}
            </Reveal>
            <Reveal delay={0.7} className="mt-14 hidden lg:block">
              <ImageReveal src={IMG.kontakt} alt="Heller Wohnraum" className="aspect-[4/5] max-w-xs" />
            </Reveal>
          </div>
          <Reveal delay={0.4} className="lg:col-span-8 lg:col-start-5 bg-white p-6 sm:p-10 md:p-14 border border-line">
            <QuoteWizard preset={preset} compact />
          </Reveal>
        </div>
      </section>
      <FAQ />
    </>
  );
}
